module.exports = __webpack_public_path__ + "static/media/Follower_Button.00a878d2.png";